import { render, staticRenderFns } from "./CurrencyConfig.vue?vue&type=template&id=16611d4b&"
import script from "./CurrencyConfig.vue?vue&type=script&lang=js&"
export * from "./CurrencyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports